import styled from "styled-components";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";

export const Title = styled.h1`
  color: ${({ theme }) => theme.COLORS.WHITE};
  font-weight: 500;
  font-size: ${calcRem(24)};
`;

export const FormWrapper = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 20px;

  ${mediaQuery.isMobile} {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const SubTitle = styled.div`
  padding: 20px 0;
`;

export const FormItem = styled.div`
  background-color: ${({ theme }) => theme.COLORS.WIDGETCOLOR};
  padding: 26px 30px;
  border-radius: 5px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  width: 100%;
  ${mediaQuery.isMobile} {
    padding: 16px 20px;
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  ${FLEX.FlexCenterCenter};
  padding: 20px 0;
`;

export const UploadWrapper = styled.div`
  width: 100%;
  padding: 20px 0;
  display: inline-flex;
`;
